module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.eot?ec813c5b36705e64ba121073b315cb52";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.eot
// module id = MFSd
// module chunks = 29